import { TIMEZONE } from "config/headers";
import { formatInTimeZone } from "date-fns-tz";
import { SkuStatusIds } from "types/common-types";
import { standardDateTimeFormat } from "utils/dateUtils";

export const missingValue = "—";

const statusDotColors: Record<string, string> = {
  [SkuStatusIds.Draft]: "grey.500",
  [SkuStatusIds.Published]: "success.main",
  [SkuStatusIds.Archived]: "warning.main",
};

export const skuStatusDotColor = (skuStatusId?: string): string =>
  (skuStatusId && statusDotColors[skuStatusId]) || "grey.500";

export const formatModifiedOn = (modifiedOn?: Date): string =>
  modifiedOn
    ? `${formatInTimeZone(modifiedOn, TIMEZONE!, standardDateTimeFormat)} ET`
    : missingValue;
